'use client';

import { useMemo } from 'react';
import { useUser } from '~/app/_ui/shared/UserProvider/UserProvider';

/** User metadata logged in each event. */
interface AnalyticsUserCommonMetadata {
  userEmail: string;
}
export default function useAnalyticsCommonMetadataUser(): AnalyticsUserCommonMetadata {
  const user = useUser();

  return useMemo(
    () => ({
      userEmail: user.email,
    }),
    [user.email],
  );
}
